import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from "@angular/router";
import {NgRedux, select} from "@angular-redux/store";
import {Observable} from "rxjs/Observable";
import {LOGIN_TO_TOUCH_CLIENT} from "./api-permission";
import {IUser} from "../../redux-store/session/session.types";
import {combineLatest} from "rxjs/observable/combineLatest";
import {map} from "rxjs/operators";
import {SessionActions} from "../../actions";
import {IAppState} from "../../redux-store";

@Injectable()
export class AuthorizedGuard implements CanActivate, CanActivateChild {

  @select(['session', 'user'])
  private user$: Observable<IUser>;

  @select(['session', 'loggedIn'])
  private loggedIn$: Observable<boolean>;

  private canActivate$: Observable<boolean>;

  constructor(private router: Router, private siActions: SessionActions, private ngRx: NgRedux<IAppState>) {
    this.canActivate$ = combineLatest(this.user$, this.loggedIn$).pipe(
      map(([user, loggedIn]) => {

        if (!user || !loggedIn) {
          this.redirectToLogin();
          return false;
        }

        const isTouchUser = user.permissions && user.permissions.indexOf(LOGIN_TO_TOUCH_CLIENT) >= 0;
        if (isTouchUser) {
          this.redirectToTouch();
          return false;
        }

        return loggedIn && !isTouchUser;

      })
    );
  }

  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate$;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.canActivate(childRoute, state);
  }

  private redirectToLogin(state?: RouterStateSnapshot) {
    this.siActions.setRedirectUrl(state ? state.url : null);
    this.router.navigate(['/login']);
  }

  private redirectToTouch() {
    this.siActions.setRedirectUrl(null);
    this.router.navigate(['/touch']);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/auth/guards/authorized-guard.ts